import _ from 'underscore';

const defaultProtocols = [{
  value: 'https',
  text: 'https://',
}, {
  value: 'http',
  text: 'http://',
}];

export const buildUrl = ({ protocol = '', url = '', protocols = defaultProtocols } = {}) => {
  const prefix = (_.findWhere(
    protocols,
    { value: protocol }
  ) || { text: '' }).text;
  return `${prefix}${url}`;
};
